import React from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import { PRICE_DISCOVERY } from "../../../constants/seller-diy-constants";
import PostInspectionDiyAuctionNotStarted from "../post-inspection-diy-auction-not-started";
import PostInspectionDiyAuctionStart from "../post-inspection-diy-auction-start";
import PostInspectionDiyAuctionOver from "../post-inspection-diy-auction-over";

const PostInspectionDiyPriceDiscovery = ({
    inspectionResponse,
    handleStartDocumentation
}) => {
    const { priceDiscovery = PRICE_DISCOVERY.OVER, isAuctionNotStarted = false } = inspectionResponse || {};

    const renderLayout = () => {
        if (priceDiscovery === PRICE_DISCOVERY.NOT_STARTED || isAuctionNotStarted) return <PostInspectionDiyAuctionNotStarted />;
        if (priceDiscovery === PRICE_DISCOVERY.START) return <PostInspectionDiyAuctionStart />;
        return (
            <div>
                <PostInspectionDiyAuctionOver
                    handleStartDocumentation={handleStartDocumentation}
                />
            </div>
        );
    };

    return (
        <div>
            {renderLayout()}
        </div>
    );
};

PostInspectionDiyPriceDiscovery.propTypes = {
    inspectionResponse: PropTypes.object,
    handleStartDocumentation: PropTypes.func
};

export default PostInspectionDiyPriceDiscovery;
